import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaChildFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        gender: [
          entity.relationUser && entity.relationUser.gender != null
            ? entity.relationUser.gender
            : 'F',
          Validators.required,
        ],
        firstName: [
          entity.relationUser ? entity.relationUser.firstName : null,
          Validators.required,
        ],
        lastName: [
          entity.relationUser ? entity.relationUser.lastName : null,
          Validators.required,
        ],
        birthDate: [
          entity.relationUser ? entity.relationUser.birthDate : null,
          Validators.required,
        ],
        nationality: [
          entity.relationUser ? entity.relationUser.nationality : null,
          Validators.required,
        ],
        taxResidence: [
          entity.relationUser && entity.relationUser.taxResidence
            ? entity.relationUser.taxResidence
            : 'FR',
          Validators.required,
        ],
        legalCapacity: [
          entity.relationUser ? entity.relationUser.legalCapacity : null,
          Validators.required,
        ],
        birthLocation: [
          entity.relationUser ? entity.relationUser.birthLocation : null,
          Validators.nullValidator,
        ],
        birthZipCode: [
          entity.relationUser ? entity.relationUser.birthZipCode : null,
          Validators.nullValidator,
        ],
        birthCity: [
          entity.relationUser ? entity.relationUser.birthCity : null,
          Validators.nullValidator,
        ],
        birthCountry: [
          entity.relationUser ? entity.relationUser.birthCountry : null,
          Validators.nullValidator,
        ],
        isHandicapped: [
          entity.relationUser ? entity.relationUser.isHandicapped : false,
          Validators.required,
        ],
        inCharge: [
          entity && entity.inCharge != null && entity.inCharge != undefined
            ? entity.inCharge
            : false,
          Validators.required,
        ],
        childFiliation: [
          entity ? entity.childFiliation : null,
          Validators.required,
        ],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: 'CHILD',
      relationUser: {
        gender: this.emptyIsNull(this.form.value.gender),
        firstName: this.emptyIsNull(this.form.value.firstName),
        lastName: this.emptyIsNull(this.form.value.lastName),
        birthDate: new Date(this.form.value.birthDate).toISOString(),
        birthCity: this.emptyIsNull(this.form.value.birthCity),
        birthCountry: this.emptyIsNull(this.form.value.birthCountry),
        birthLocation: this.emptyIsNull(this.form.value.birthLocation),
        birthZipCode: this.emptyIsNull(this.form.value.birthZipCode),
        nationality: this.emptyIsNull(this.form.value.nationality),
        taxResidence: this.emptyIsNull(this.form.value.taxResidence),
        legalCapacity: this.emptyIsNull(this.form.value.legalCapacity),
        isHandicapped: this.emptyIsNull(this.form.value.isHandicapped),
      },
      inCharge: this.emptyIsNull(this.form.value.inCharge),
      childFiliation: this.emptyIsNull(this.form.value.childFiliation),
    };
    return dto;
  }
}
